<!-- BEGIN 404 error -->
<div class="error">
    <div class="error-code">404</div>
    <div class="error-content">
        <div class="error-message">Page Not Found</div>
        <div class="error-desc mb-4">
            The page you're looking for doesn't exist. <br />
            Perhaps, these pages will help you find what you're looking for.
        </div>
        <div>
            <a routerLink="/kisna-live-dashboard" class="btn sd-custom-btn rounded-2  btn-sm px-3">Go to Dashboard</a>
        </div>
    </div>
</div>
<!-- END 404 error -->